import { Injectable, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class CurrentSlideService {
	//private currentSlide: number = 0; 
	//private autoplay: boolean = true; 
	private autoLoopHome: boolean = true; 
	private slides; 

	//@Output() changeAutoplay: EventEmitter<boolean> = new EventEmitter();
	@Output() changeAutoLoopHome: EventEmitter<boolean> = new EventEmitter();
	@Output() changeSlides: EventEmitter<boolean> = new EventEmitter();

	private _currentSlide = new BehaviorSubject<number>(0);
	currentSlide = this._currentSlide.asObservable();
	public setCurrenSlide(value: number) {
		this._currentSlide.next(value);
	}


	private _autoplay = new BehaviorSubject<boolean>(true);
	autoplay = this._autoplay.asObservable();
    public setAutoplay(value: boolean) {
    	this._autoplay.next(value);
		/*this.autoplay = value;
		this.changeAutoplay.emit(this.autoplay);*/
	}
	/*public getAutoplay(): Observable<boolean> {
        return this._autoplay.asObservable();
    }*/
	/*public getAutoplay(): boolean {
        return this.autoplay;
    }*/

    public setAutoLoopHome(value: boolean) {
		this.autoLoopHome = value;
		this.changeAutoLoopHome.emit(this.autoLoopHome);
	}
	public getAutoLoopHome(): boolean {
        return this.autoLoopHome;
    }

    public setSlides(value: boolean) {
		this.slides = value;
		this.changeSlides.emit(this.slides);
	}
	public getSlides(): boolean {
        return this.slides;
    }
}
